"use client";

import { useEffect } from "react";
import { useSession } from "next-auth/react";
import { isOnline } from "@/lib/hooks/useNetworkStatus";

/**
 * Inicializa LogRocket una sola vez del lado del cliente.
 * Identifica al usuario cuando hay sesión activa para correlacionar
 * sesiones de replay con cuentas reales.
 */
export default function LogRocketInit() {
  const { data: session } = useSession();

  useEffect(() => {
    if (!isOnline()) return;
    let cancelled = false;
    import("logrocket")
      .then(({ default: LogRocket }) => {
        if (cancelled) return;
        LogRocket.init("nq7hhf/caciqueagro");
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!session?.user?.email || !isOnline()) return;
    import("logrocket")
      .then(({ default: LogRocket }) => {
        LogRocket.identify(session.user!.email!, {
          name: session.user!.name || "",
          email: session.user!.email!,
        });
      })
      .catch(() => {});
  }, [session?.user?.email, session?.user?.name]);

  return null;
}
